import { BaseNode } from '../hooks/useNearbyBaseNodes';

/**
 * Resolves a BaseNode from a property value that may be:
 * - A JSON string that needs to be parsed
 * - An object that can be used directly
 * - null/undefined
 *
 * @param nodeValue - The value to resolve, which may be a string, object, or null/undefined
 * @param propertyKey - Optional property key for error logging
 * @returns The resolved BaseNode, or undefined if the value cannot be resolved
 */
export const resolveBaseNode = (
  nodeValue: unknown,
  propertyKey?: string
): BaseNode | undefined => {
  if (!nodeValue) {
    return undefined;
  }

  if (typeof nodeValue === 'string') {
    try {
      return JSON.parse(nodeValue) as BaseNode;
    } catch (e) {
      console.warn(
        `[BNResolver] Failed to parse ${propertyKey || 'node'} as JSON:`,
        e
      );
      return undefined;
    }
  }

  if (typeof nodeValue === 'object' && nodeValue !== null) {
    return nodeValue as BaseNode;
  }

  return undefined;
};
